module.exports = __webpack_public_path__ + "img/mandala-bg - Copia.a9b6adcc.png";